import { REDUCED_TAX_RATE_TYPE } from "@/const/codes";
import { REDUCED_TAX_PREFIX } from "@/const/values";


/**
 * ���i���̓���[�y]������
 * @param goodsName - ���i��
 * @param reducedTaxRateType - �y���ŗ��敪
 * @return �c�S�ŗ��Ώۏ��i�̏ꍇ�A���i���̓���[�y]��t���ĕԂ�
 */
export const getReducedGoodsName = (goodsName: string, reducedTaxRateType: string): string => {
    try {

        if (reducedTaxRateType == REDUCED_TAX_RATE_TYPE.REDUCED) {
            return REDUCED_TAX_PREFIX + goodsName;
        }

        return goodsName;

    } catch {
        return '';
    }
}

